<script setup lang="ts">
    type icons =
        | 'chat'
        | 'support'
        | 'signout'
        | 'journeys'
        | 'email'
        | 'survey'
        | 'event'
        | 'textmessage'
        | 'contacts'
        | 'create'
        | 'newuser'
        | 'close'
        | 'plus'
        | 'notifications'
        | 'more-vertical'
        | 'media'
        | 'segments'
        | 'web'
        | 'backoffice'
        | 'maximize'
        | 'minimize'
        | 'search'
        | 'star'
        | 'check'
        | 'arrow-right'
        | 'trash';

    const props = defineProps<{
        icon: icons;
        size?: number;
        color?: string;
        strokeWidth?: number;
    }>();
</script>

<script lang="ts"></script>

<template>
    <svg
        v-if="props.icon === 'email'"
        xmlns="http://www.w3.org/2000/svg"
        :width="props.size || 24"
        :height="props.size || 24"
        viewBox="0 0 24 24"
        fill="none"
        :stroke="props.color || 'currentColor'"
        :stroke-width="props.strokeWidth || '2'"
        stroke-linecap="round"
        stroke-linejoin="round"
        class="feather feather-send">
        <line x1="22" y1="2" x2="11" y2="13"></line>
        <polygon points="22 2 15 22 11 13 2 9 22 2"></polygon>
    </svg>

    <svg
        v-if="props.icon === 'create'"
        xmlns="http://www.w3.org/2000/svg"
        :width="props.size || 24"
        :height="props.size || 24"
        viewBox="0 0 24 24"
        fill="none"
        :stroke="props.color || 'currentColor'"
        :stroke-width="props.strokeWidth || '2'"
        stroke-linecap="round"
        stroke-linejoin="round"
        class="feather feather-edit">
        <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
        <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>
    </svg>

    <svg
        v-if="props.icon === 'survey'"
        xmlns="http://www.w3.org/2000/svg"
        :width="props.size || 24"
        :height="props.size || 24"
        viewBox="0 0 24 24"
        fill="none"
        :stroke="props.color || 'currentColor'"
        :stroke-width="props.strokeWidth || '2'"
        stroke-linecap="round"
        stroke-linejoin="round"
        class="feather feather-check-circle">
        <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
        <polyline points="22 4 12 14.01 9 11.01"></polyline>
    </svg>

    <svg
        v-if="props.icon === 'event'"
        xmlns="http://www.w3.org/2000/svg"
        :width="props.size || 24"
        :height="props.size || 24"
        viewBox="0 0 24 24"
        fill="none"
        :stroke="props.color || 'currentColor'"
        :stroke-width="props.strokeWidth || '2'"
        stroke-linecap="round"
        stroke-linejoin="round"
        class="feather feather-calendar">
        <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
        <line x1="16" y1="2" x2="16" y2="6"></line>
        <line x1="8" y1="2" x2="8" y2="6"></line>
        <line x1="3" y1="10" x2="21" y2="10"></line>
    </svg>

    <svg
        v-if="props.icon === 'textmessage'"
        xmlns="http://www.w3.org/2000/svg"
        :width="props.size || 24"
        :height="props.size || 24"
        viewBox="0 0 24 24"
        fill="none"
        :stroke="props.color || 'currentColor'"
        :stroke-width="props.strokeWidth || '2'"
        stroke-linecap="round"
        stroke-linejoin="round"
        class="feather feather-smartphone">
        <rect x="5" y="2" width="14" height="20" rx="2" ry="2"></rect>
        <line x1="12" y1="18" x2="12.01" y2="18"></line>
    </svg>

    <svg
        v-if="props.icon === 'contacts'"
        xmlns="http://www.w3.org/2000/svg"
        :width="props.size || 24"
        :height="props.size || 24"
        viewBox="0 0 24 24"
        fill="none"
        :stroke="props.color || 'currentColor'"
        :stroke-width="props.strokeWidth || '2'"
        stroke-linecap="round"
        stroke-linejoin="round"
        class="feather feather-users">
        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
        <circle cx="9" cy="7" r="4"></circle>
        <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
        <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
    </svg>

    <svg
        v-if="props.icon === 'newuser'"
        xmlns="http://www.w3.org/2000/svg"
        :width="props.size || 24"
        :height="props.size || 24"
        viewBox="0 0 24 24"
        fill="none"
        :stroke="props.color || 'currentColor'"
        :stroke-width="props.strokeWidth || '2'"
        stroke-linecap="round"
        stroke-linejoin="round"
        class="feather feather-user-plus">
        <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
        <circle cx="8.5" cy="7" r="4"></circle>
        <line x1="20" y1="8" x2="20" y2="14"></line>
        <line x1="23" y1="11" x2="17" y2="11"></line>
    </svg>

    <svg
        v-if="props.icon === 'close'"
        xmlns="http://www.w3.org/2000/svg"
        :width="props.size || 24"
        :height="props.size || 24"
        viewBox="0 0 24 24"
        fill="none"
        :stroke="props.color || 'currentColor'"
        :stroke-width="props.strokeWidth || '2'"
        stroke-linecap="round"
        stroke-linejoin="round"
        class="feather feather-x">
        <line x1="18" y1="6" x2="6" y2="18"></line>
        <line x1="6" y1="6" x2="18" y2="18"></line>
    </svg>

    <svg
        v-if="props.icon === 'plus'"
        xmlns="http://www.w3.org/2000/svg"
        :width="props.size || 24"
        :height="props.size || 24"
        viewBox="0 0 24 24"
        fill="none"
        :stroke="props.color || 'currentColor'"
        :stroke-width="props.strokeWidth || '2'"
        stroke-linecap="round"
        stroke-linejoin="round"
        class="feather feather-plus">
        <line x1="12" y1="5" x2="12" y2="19"></line>
        <line x1="5" y1="12" x2="19" y2="12"></line>
    </svg>

    <svg
        v-if="props.icon === 'journeys'"
        xmlns="http://www.w3.org/2000/svg"
        :width="props.size || 24"
        :height="props.size || 24"
        viewBox="0 0 24 24"
        fill="none"
        :stroke="props.color || 'currentColor'"
        :stroke-width="props.strokeWidth || '2'"
        stroke-linecap="round"
        stroke-linejoin="round">
        <circle cx="6" cy="5" r="3" />
        <rect x="15" y="16" width="6" height="6" />
        <path d="M9,5h5.5A3.5,3.5,0,0,1,18,8.5h0A3.5,3.5,0,0,1,14.5,12H9.7A3.7,3.7,0,0,0,6,15.7H6A3.3,3.3,0,0,0,9.3,19H15" />
    </svg>

    <svg
        v-if="props.icon === 'support'"
        xmlns="http://www.w3.org/2000/svg"
        :width="props.size || 24"
        :height="props.size || 24"
        viewBox="0 0 24 24"
        fill="none"
        :stroke="props.color || 'currentColor'"
        :stroke-width="props.strokeWidth || '2'"
        stroke-linecap="round"
        stroke-linejoin="round"
        class="feather feather-help-circle">
        <circle cx="12" cy="12" r="10"></circle>
        <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"></path>
        <line x1="12" y1="17" x2="12.01" y2="17"></line>
    </svg>

    <svg
        v-if="props.icon === 'chat'"
        xmlns="http://www.w3.org/2000/svg"
        :width="props.size || 24"
        :height="props.size || 24"
        viewBox="0 0 24 24"
        fill="none"
        :stroke="props.color || 'currentColor'"
        :stroke-width="props.strokeWidth || '2'"
        stroke-linecap="round"
        stroke-linejoin="round"
        class="feather feather-message-circle">
        <path
            d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"></path>
    </svg>

    <svg
        v-if="props.icon === 'signout'"
        xmlns="http://www.w3.org/2000/svg"
        :width="props.size || 24"
        :height="props.size || 24"
        viewBox="0 0 24 24"
        fill="none"
        :stroke="props.color || 'currentColor'"
        :stroke-width="props.strokeWidth || '2'"
        stroke-linecap="round"
        stroke-linejoin="round"
        class="feather feather-log-out">
        <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
        <polyline points="16 17 21 12 16 7"></polyline>
        <line x1="21" y1="12" x2="9" y2="12"></line>
    </svg>

    <svg
        v-if="props.icon === 'notifications'"
        xmlns="http://www.w3.org/2000/svg"
        :width="props.size || 24"
        :height="props.size || 24"
        viewBox="0 0 24 24"
        fill="none"
        :stroke="props.color || 'currentColor'"
        :stroke-width="props.strokeWidth || '2'"
        stroke-linecap="round"
        stroke-linejoin="round"
        class="feather feather-bell">
        <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
        <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
    </svg>

    <svg
        v-if="props.icon === 'more-vertical'"
        xmlns="http://www.w3.org/2000/svg"
        :width="props.size || 24"
        :height="props.size || 24"
        viewBox="0 0 24 24"
        fill="none"
        :stroke="props.color || 'currentColor'"
        :stroke-width="props.strokeWidth || '2'"
        stroke-linecap="round"
        stroke-linejoin="round"
        class="feather feather-more-vertical">
        <circle cx="12" cy="12" r="1"></circle>
        <circle cx="12" cy="5" r="1"></circle>
        <circle cx="12" cy="19" r="1"></circle>
    </svg>

    <svg
        v-if="props.icon === 'media'"
        xmlns="http://www.w3.org/2000/svg"
        :width="props.size || 24"
        :height="props.size || 24"
        viewBox="0 0 24 24"
        fill="none"
        :stroke="props.color || 'currentColor'"
        :stroke-width="props.strokeWidth || '2'"
        stroke-linecap="round"
        stroke-linejoin="round">
        <path d="M16,8h5v10.5c0,1.4-1.1,2.5-2.5,2.5h-13C4.1,21,3,19.9,3,18.5L3,3h13v15.5c0,1.4,1.1,2.5,2.5,2.5" />
        <line x1="12" y1="12" x2="7" y2="12" />
        <line x1="12" y1="8" x2="7" y2="8" />
        <line x1="12" y1="16" x2="7" y2="16" />
    </svg>

    <svg
        v-if="props.icon === 'segments'"
        xmlns="http://www.w3.org/2000/svg"
        :width="props.size || 24"
        :height="props.size || 24"
        viewBox="0 0 24 24"
        fill="none"
        :stroke="props.color || 'currentColor'"
        :stroke-width="props.strokeWidth || '2'"
        stroke-linecap="round"
        stroke-linejoin="round"
        class="feather feather-filter">
        <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"></polygon>
    </svg>

    <svg
        v-if="props.icon === 'web'"
        xmlns="http://www.w3.org/2000/svg"
        :width="props.size || 24"
        :height="props.size || 24"
        viewBox="0 0 24 24"
        fill="none"
        :stroke="props.color || 'currentColor'"
        :stroke-width="props.strokeWidth || '2'"
        stroke-linecap="round"
        stroke-linejoin="round"
        class="feather feather-globe">
        <circle cx="12" cy="12" r="10"></circle>
        <line x1="2" y1="12" x2="22" y2="12"></line>
        <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"></path>
    </svg>

    <svg
        v-if="props.icon === 'backoffice'"
        xmlns="http://www.w3.org/2000/svg"
        :width="props.size || 24"
        :height="props.size || 24"
        viewBox="0 0 24 24"
        fill="none"
        :stroke="props.color || 'currentColor'"
        :stroke-width="props.strokeWidth || '2'"
        stroke-linecap="round"
        stroke-linejoin="round"
        class="feather feather-briefcase">
        <rect x="2" y="7" width="20" height="14" rx="2" ry="2"></rect>
        <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"></path>
    </svg>

    <svg
        v-if="props.icon === 'maximize'"
        xmlns="http://www.w3.org/2000/svg"
        :width="props.size || 24"
        :height="props.size || 24"
        viewBox="0 0 24 24"
        fill="none"
        :stroke="props.color || 'currentColor'"
        :stroke-width="props.strokeWidth || '2'"
        stroke-linecap="round"
        stroke-linejoin="round"
        class="feather feather-maximize-2">
        <polyline points="15 3 21 3 21 9"></polyline>
        <polyline points="9 21 3 21 3 15"></polyline>
        <line x1="21" y1="3" x2="14" y2="10"></line>
        <line x1="3" y1="21" x2="10" y2="14"></line>
    </svg>

    <svg
        v-if="props.icon === 'minimize'"
        xmlns="http://www.w3.org/2000/svg"
        :width="props.size || 24"
        :height="props.size || 24"
        viewBox="0 0 24 24"
        fill="none"
        :stroke="props.color || 'currentColor'"
        :stroke-width="props.strokeWidth || '2'"
        stroke-linecap="round"
        stroke-linejoin="round"
        class="feather feather-minimize-2">
        <polyline points="4 14 10 14 10 20"></polyline>
        <polyline points="20 10 14 10 14 4"></polyline>
        <line x1="14" y1="10" x2="21" y2="3"></line>
        <line x1="3" y1="21" x2="10" y2="14"></line>
    </svg>

    <svg
        v-if="props.icon === 'search'"
        xmlns="http://www.w3.org/2000/svg"
        :width="props.size || 24"
        :height="props.size || 24"
        viewBox="0 0 24 24"
        fill="none"
        :stroke="props.color || 'currentColor'"
        :stroke-width="props.strokeWidth || '2'"
        stroke-linecap="round"
        stroke-linejoin="round"
        class="feather feather-search">
        <circle cx="11" cy="11" r="8"></circle>
        <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
    </svg>

    <svg
        v-if="props.icon === 'star'"
        class="feather feather-star"
        xmlns="http://www.w3.org/2000/svg"
        :width="props.size || 24"
        :height="props.size || 24"
        viewBox="0 0 24 24"
        fill="none"
        :stroke="props.color || 'currentColor'"
        :stroke-width="props.strokeWidth || '2'"
        stroke-linecap="round"
        stroke-linejoin="round">
        <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>
    </svg>

    <svg
        v-if="props.icon === 'check'"
        xmlns="http://www.w3.org/2000/svg"
        :width="props.size || 24"
        :height="props.size || 24"
        viewBox="0 0 24 24"
        fill="none"
        :stroke="props.color || 'currentColor'"
        :stroke-width="props.strokeWidth || '2'"
        stroke-linecap="round"
        stroke-linejoin="round">
        <polyline points="20 6 9 17 4 12"></polyline>
    </svg>

    <svg
        v-if="props.icon === 'arrow-right'"
        xmlns="http://www.w3.org/2000/svg"
        :width="props.size || 24"
        :height="props.size || 24"
        viewBox="0 0 24 24"
        fill="none"
        :stroke="props.color || 'currentColor'"
        :stroke-width="props.strokeWidth || '2'"
        stroke-linecap="round"
        stroke-linejoin="round"
        style="opacity: 0.5; margin-right: 5px">
        <line x1="5" y1="12" x2="19" y2="12"></line>
        <polyline points="12 5 19 12 12 19"></polyline>
    </svg>

    <svg
        v-if="props.icon === 'trash'"
        xmlns="http://www.w3.org/2000/svg"
        :width="props.size || 24"
        :height="props.size || 24"
        viewBox="0 0 24 24"
        fill="none"
        :stroke="props.color || 'currentColor'"
        :stroke-width="props.strokeWidth || '2'"
        stroke-linecap="round"
        stroke-linejoin="round"
        class="feather feather-trash">
        <polyline points="3 6 5 6 21 6"></polyline>
        <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
    </svg>
</template>

<style scoped></style>

<style></style>
